module.exports = __webpack_public_path__ + "static/igloo.f156e04c.svg";